// extracted by mini-css-extract-plugin
module.exports = {"slide":"ReviewsSwiper_slide__wiHhk","slideVideos":"ReviewsSwiper_slideVideos__BXV2M"};